import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationDataOptions, NzNotificationRef, NzNotificationService } from 'ng-zorro-antd/notification';

import { PopupNotificationType } from '../../constants';
import { PopupNotificationTemplate } from '../../constants/types';

@Injectable({
    providedIn: 'root'
})
export class PopupNotificationService {
    private readonly notification = inject(NzNotificationService);
    private readonly translate = inject(TranslateService);

    public createNotification(
        type: PopupNotificationType,
        titleKey: string,
        content: string,
        fallbackContentKey?: string,
        fallbackContentKeyInterpolateParams?: unknown,
        options?: NzNotificationDataOptions
    ): void {
        this.notification.create(
            type,
            this.translate.instant(titleKey),
            content
                ? this.translate.instant(content)
                : fallbackContentKey
                  ? this.translate.instant(fallbackContentKey, fallbackContentKeyInterpolateParams)
                  : '',
            options
        );
    }

    public createNotificationWithTemplate(
        notificationTemplate: PopupNotificationTemplate,
        options?: NzNotificationDataOptions
    ): NzNotificationRef {
        return this.notification.template(notificationTemplate, options);
    }

    public removeNotification(notificationId: string): void {
        this.notification.remove(notificationId);
    }
}
